import styled from 'styled-components'
import { blue } from '../../styles/variables'

const List = styled.div`
  min-width: 300px;

`

const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 5px 10px 0;
  & > img {
    margin-right: 10px;
  }

  &.category {
    font-weight: bold;
    font-size: 18px;
    margin-top: 30px;
    margin-bottom: 10px;
    &:first-child {
      margin-top: 0;
    }
  }

  & > .icon {
    cursor: pointer;
    transition: all .1s ease-in-out;
    &:hover {
      transform: scale(1.1);
    }

    &.edit {
      margin-left: 10px;
    }
  }

  &.addIcon > img {
    margin-left: 30px;
  }

  &.addCategory {
    color: #444;
    cursor: pointer;
    margin-top: 20px;
    & > img {
      margin-left: 0;
    }
    &:hover {
      opacity: 0.7;
    }
  }

  &.subcategory {
    margin: 15px 0;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }

  &.error {
    color: red;
  }

  &.selected {
    color: ${blue};
    opacity: 1 !important;
  }

  &.subchildren {
    margin: -15px 5px 15px 30px;
  }

  &.subitem {
    margin-top: -10px;
  }
`

const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5px;

  &.subcategory {
    padding-top: 15px;
  }
`
const ItemInfoTitle = styled.div`
  font-weight: bold;
`
const ItemInfoDescription = styled.div`
  font-size: 12px;
`

const Delete = styled.div`
  margin-left: 10px;
  cursor: pointer;
  color: #999;
  align-self: flex-start;
  &:hover {
    transform: scale(1.1);
    color: red;
  }
`

const RefTo = styled.div`
  margin-left: 10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  align-self: flex-start;
`

const Refs = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 10px;
  align-self: flex-start;
`

const RefFrom = styled.div`
  font-size: 20px;
  align-self: flex-start;
`

const Placeholder = styled.div`
  width: 25px;
`

export default {
  List,
  ListItem,
  ItemInfo,
  ItemInfoTitle,
  ItemInfoDescription,
  Delete,
  RefTo,
  RefFrom,
  Refs,
  Placeholder,
}
